import React, { useState } from 'react';
import { ChevronDown, User, LogOut } from 'lucide-react';
import { getCurrentUser, useLogout } from '../../pages/Login/queries';
import { useUserDocuments } from '../../pages/Staffs/queries';

const Header: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const user = getCurrentUser();
  const { mutate: logout, isPending } = useLogout();
  const { data: userDocuments } = useUserDocuments(user?.id ?? null);

  return (
    <header className="bg-white border-b border-gray-200 h-16">
      <div className="h-full px-6 flex items-center justify-between">
        {/* Logo and App Name */}
        <div className="flex items-center gap-3">
          <img
            src="/web_logo.png"
            alt="Retiss Logo"
            className="h-10 w-10 object-contain"
          />
          <h1 className="text-2xl font-bold text-[#183059]">
            Staff IRIS
          </h1>
        </div>

        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center space-x-3 text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden">
              {userDocuments?.profilePhoto ? (
                <img src={userDocuments.profilePhoto} alt={user?.name || 'User'} className="w-full h-full object-cover" />
              ) : (
                <User className="w-4 h-4 text-gray-600" />
              )}
            </div>
            <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
              <div className="py-1">
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-sm font-medium text-gray-900">{user?.name || 'User'}</p>
                  <p className="text-sm text-gray-500">{user?.email || ''}</p>
                </div>

                {/* <button
                  onClick={() => toast('Coming soon', { icon: '🚀' })}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <User className="mr-3 h-4 w-4" />
                  Profile
                </button>
                <button
                  onClick={() => toast('Coming soon', { icon: '🚀' })}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <Settings className="mr-3 h-4 w-4" />
                  Settings
                </button> */}
                <button
                  onClick={() => logout()}
                  disabled={isPending}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                >
                  <LogOut className="mr-3 h-4 w-4" />
                  {isPending ? 'Signing out...' : 'Sign out'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {isDropdownOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setIsDropdownOpen(false)} />
      )}
    </header>
  );
};

export default Header;